import { Outlet, Navigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { LayoutDashboard, Building2, Award, MessageSquare, LogOut, ChevronLeft } from 'lucide-react';

const LOGO_URL = "/logo.png";

const sidebarLinks = [
  { name: 'Dashboard', href: '/admin', icon: LayoutDashboard },
  { name: 'Immobilien', href: '/admin/properties', icon: Building2 },
  { name: 'Referenzen', href: '/admin/references', icon: Award },
  { name: 'Anfragen', href: '/admin/leads', icon: MessageSquare },
];

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#131d30] flex items-center justify-center">
        <div className="spinner" />
      </div>
    );
  }

  if (!user || user.role !== 'admin') {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <div className="min-h-screen bg-[#131d30] flex">
      {/* Sidebar */}
      <aside className="w-64 bg-[#0a1120] border-r border-[#d1af6a]/20 flex flex-col">
        {/* Logo */}
        <div className="p-6 border-b border-[#d1af6a]/20">
          <Link to="/" className="flex items-center gap-2">
            <img src={LOGO_URL} alt="Dogan Immobilien" className="h-10 w-auto" />
          </Link>
          <p className="text-[#c8c6c4] text-xs mt-2">Admin-Bereich</p>
        </div>

        {/* Navigation */}
        <nav className="flex-1 p-4 space-y-2">
          {sidebarLinks.map((link) => {
            const isActive = location.pathname === link.href;
            const Icon = link.icon;
            return (
              <Link
                key={link.href}
                to={link.href}
                className={`flex items-center gap-3 px-4 py-3 rounded-none transition-colors ${
                  isActive
                    ? 'bg-[#d1af6a]/10 text-[#d1af6a] border-l-2 border-[#d1af6a]'
                    : 'text-[#c8c6c4] hover:text-white hover:bg-[#1a2640]'
                }`}
                data-testid={`admin-nav-${link.name.toLowerCase()}`}
              >
                <Icon className="w-5 h-5" />
                <span className="font-medium text-sm">{link.name}</span>
              </Link>
            );
          })}
        </nav>

        {/* Footer */}
        <div className="p-4 border-t border-[#d1af6a]/20 space-y-4">
          <Link
            to="/"
            className="flex items-center gap-2 text-[#c8c6c4] hover:text-[#d1af6a] transition-colors text-sm"
          >
            <ChevronLeft className="w-4 h-4" />
            Zur Website
          </Link>
          <button
            onClick={logout}
            className="flex items-center gap-2 text-[#c8c6c4] hover:text-red-400 transition-colors text-sm w-full"
            data-testid="admin-logout"
          >
            <LogOut className="w-4 h-4" />
            Abmelden
          </button>
          <p className="text-[#c8c6c4]/50 text-xs">
            Angemeldet als {user.email}
          </p>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
